import { render, staticRenderFns } from "./helpSetBox.vue?vue&type=template&id=3a4c0c7a&scoped=true"
import script from "./helpSetBox.vue?vue&type=script&lang=js"
export * from "./helpSetBox.vue?vue&type=script&lang=js"
import style0 from "./helpSetBox.vue?vue&type=style&index=0&id=3a4c0c7a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c0c7a",
  null
  
)

export default component.exports